module.exports = __webpack_public_path__ + "static/media/4@1920w.cc7b470c.jpg";